<template>
  <div class="full">
    <Pipeline ref="pipeline" style="width: 100%; height: 100%;" v-if="toucher" :toucher="toucher" :useBloom="useBloom" :bloomPassConfig="bloomPass">
      <template slot-scope="temp" slot="scene">
        <Particles :amount="200" v-if="temp" :engine="temp"></Particles>
        <!-- <LoadingGL :visible="true" @add-exec="(fn) => { temp.execStack.push(fn) }" :scene="temp.scene" :exec="temp.execStack" :renderer="temp.renderer"></LoadingGL> -->
        <!-- <GeoVert :exec="temp.execMap" :renderer="temp.renderer" :scene="temp.scene" v-if="temp.renderer && temp.scene" /> -->
      </template>
    </Pipeline>
    <div class="overlay" ref="toucher"></div>
    <GameMenu class="overlay full"
     @choose="onChoose"
    >
    </GameMenu>
  </div>
</template>

<script>
export default {
  components: {
    Pipeline: require('../game/Pipeline.vue').default,
    GameMenu: require('../game-ui/GameMenu.vue').default,
    GeoVert: require('../vfx/SceneItem/GeoVert.vue').default,
    Particles: require('../game/Particles.vue').default,
    LoadingGL: require('../game/LoadingGL.vue').default
  },
  data () {
    return {
      role: 'student',
      toucher: false,
      useBloom: true,
      bloomPass: {
        useBloom: true,
        threshold: 0.0846740050804403,
        strength: 0.9551227773073666,
        radius: 1.3343776460626588
      }
    }
  },
  mounted () {
    this.toucher = this.$refs.toucher
  },
  methods: {
    onChoose (v) {
      this.role = v
      if (v === 'student') {
        this.$router.push({
          path: '/game-lobby/',
          // query: {
          //   retry: this.$route.query.retry
          // }
        })
      } else if (v === 'teacher') {
        this.$router.push({
          path: '/teacher-login'
        })
      }
    }
  }
}
</script>

<style scoped>
.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* background-color: red; */
}
</style>
